import validationMessage from './messages';

export function required(messageID: string) {
    return (value: any) => {
        if (!value || _isEmptyString(value))
            return validationError(messageID);
    };
}

function _isEmptyString(value: string) {
    return !value.toString().trim();
}

export function validationError(message = 'required') {
    return validationMessage[message as keyof typeof validationMessage];
}